const currenciesSymbols = {
  EUR: "€",
};

export default currenciesSymbols;
